import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import 'rxjs/Rx';
import { Observable } from 'rxjs/Rx';
import { ConfigService } from '../../config/config.service';
import { SessionService } from './session.service';
import { CommonDataService } from './common-data.service';
import { httpExtensionService } from './httpextension.service';
@Injectable()
export class SettingsService {

    constructor(
        private http: httpExtensionService,
        private config: ConfigService,
        private sessionService: SessionService,
        private commonDataService: CommonDataService
    ) { }

    changeMemberPassword(passwordData) {
        let body = this.commonDataService.urlDataDecoded(passwordData);
        let user_token: string = this.sessionService.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.http.post(this.config.apiURI + this.config.changeMemberPassword, body, {
            headers: headers
        })
    }

    setDefaultBeneficiary(id, data) {
        let body = data;
        let user_token: string = this.sessionService.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.http.put(this.config.apiURI + this.config.setBeneficiary(id), body, {
            headers: headers
        })
    }

    createSubscription(data) {
        let body = data;
        let user_token: string = this.sessionService.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.post(this.config.createSubscription, body, {
            headers: headers
        })
    }

    cancelSubscription(subscriptionId) {
        let user_token: string = this.sessionService.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.put(this.config.cancelSubscription(subscriptionId), '',{
            headers: headers
        })
    }

    listSalesRep(userData) {
        let body = userData;
        let user_token: string = this.sessionService.getToken();
        let headers = new Headers();
        // headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.post(this.config.salesRepList, body, {
            headers: headers
        })
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/settings.service.ts